<template>
  <div class="visitor-to-study">
    <div class="page-header">
      <h1 class="main-title">旅游签证转学习签证</h1>
      <div class="sub-title">学习签证</div>
    </div>

    <div class="content-section">
      <p class="intro-text">
        加拿大旅游转转学签，也被称为加拿大境转学，可指由持人以旅游签证进入加拿大，并在加拿大境内的DLI（指定教育机构）完成6个月以下的短期课程（或常为语言课程）。然后合法加拿大境内申请学签，获得学习许可的同时可以通过转换身份方式转移到加拿大持准留。
      </p>

      <div class="section">
        <h2>为什么要申请旅游签转学签</h2>
        <p>
          维大部分申请就读加拿大语言课程和比较宽松、大众、简单、有把握记录、如此的转移记录，是否有犯罪记录的申请人，从境直接在境外申请加拿大学签，获批的几率非常低。
        </p>
      </div>

      <div class="section">
        <h2>旅游签证转学签适合人群</h2>
        <ul class="suitable-list">
          <li>
            <strong>商旅人士：</strong>包括父母是身人已经在加拿大，并且愿有合法的临时居民身份，允许过境适合调整，允公司符合在加拿大境内申请学签
          </li>
          <li>
            <strong>未来申请者：</strong>30多岁的年龄加拿大诚做创新的学历和学习，从境地上被较不合理
          </li>
          <li>
            <strong>学历背景特殊申请人：</strong>本身具有高学历，打算申请加拿大学低学历，属于"学历倒挂"，不合理
          </li>
          <li>
            <strong>资金来源一般的申请人：</strong>如境资产不充足，或无法提供资金的原来证明，境内申请大概率被拒
          </li>
          <li>
            <strong>有在拒签记录的申请人：</strong>有在签记录的申请人，在境内申请通过证，通过率非常低
          </li>
        </ul>
      </div>

      <div class="section">
        <p class="note">
          在加拿大境游签证转学签的最大优势是易于批准的把握，并且对申请人的申请、学历、工作背景、托福记录等等要求相对比常宽松，批准率比较高。
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VisitorToStudyView'
}
</script>

<style scoped>
.visitor-to-study {
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem;
}

.page-header {
  text-align: center;
  margin-bottom: 3rem;
}

.main-title {
  font-size: 2.5rem;
  color: #333;
  margin-bottom: 0.5rem;
}

.sub-title {
  font-size: 1.2rem;
  color: #666;
}

.content-section {
  background: #fff;
  padding: 2rem;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.intro-text {
  font-size: 1.1rem;
  line-height: 1.8;
  color: #444;
  margin-bottom: 2rem;
}

.section {
  margin-bottom: 2.5rem;
}

.section h2 {
  font-size: 1.8rem;
  color: #2c3e50;
  margin-bottom: 1.5rem;
  padding-bottom: 0.5rem;
  border-bottom: 2px solid #eee;
}

.suitable-list {
  list-style: none;
  padding: 0;
}

.suitable-list li {
  margin-bottom: 1.2rem;
  padding: 1rem;
  background: #f8f9fa;
  border-radius: 6px;
  transition: all 0.3s ease;
}

.suitable-list li:hover {
  transform: translateX(10px);
  background: #f0f2f5;
}

.suitable-list strong {
  color: #2c3e50;
  display: block;
  margin-bottom: 0.5rem;
}

.note {
  font-style: italic;
  color: #666;
  padding: 1rem;
  background: #f8f9fa;
  border-left: 4px solid #2c3e50;
  margin-top: 2rem;
}
</style>